import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import RadarChartOutlined from '@ant-design/icons/RadarChartOutlined';
import CustomerServiceOutlined from '@ant-design/icons/CustomerServiceOutlined';
import BugOutlined from '@ant-design/icons/BugOutlined';
import RetweetOutlined from '@ant-design/icons/RetweetOutlined';
import BookOutlined from '@ant-design/icons/BookOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import UserSwitchOutlined from '@ant-design/icons/UserSwitchOutlined';
import InboxOutlined from '@ant-design/icons/InboxOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import FileProtectOutlined from '@ant-design/icons/FileProtectOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import FolderOutlined from '@ant-design/icons/FolderOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import TagsOutlined from '@ant-design/icons/TagsOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';
import ThunderboltOutlined from '@ant-design/icons/ThunderboltOutlined';
import FilterOutlined from '@ant-design/icons/FilterOutlined';
import UnorderedListOutlined from '@ant-design/icons/UnorderedListOutlined';
import KeyOutlined from '@ant-design/icons/KeyOutlined';
import UploadOutlined from '@ant-design/icons/UploadOutlined';
import MailOutlined from '@ant-design/icons/MailOutlined';
import GlobalOutlined from '@ant-design/icons/GlobalOutlined';
import UsergroupAddOutlined from '@ant-design/icons/UsergroupAddOutlined';
import ScheduleOutlined from '@ant-design/icons/ScheduleOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';

// O menu é lido por quem vê TUDO: Suporte, Desenvolvedores e Diretoria têm todas as permissões do
// Helpdesk, e eram 18 itens soltos mais 11 em Configurações. A regra aqui é altitude por frequência:
// o que se usa toda hora fica solto; o que se abre às vezes vai para um grupo por assunto; e o que
// se configura uma vez vai para Configurações, dividida em blocos. Grupo cujo usuário não vê nenhum
// filho some sozinho (NavCollapse), então agrupar não custa nada a quem tem permissão estreita.
//
// A Lixeira saiu daqui de propósito: é uma visão da lista de tickets (Lista · Kanban · Lixeira), não
// um destino de navegação.
const helpdesk = {
  id: 'group-helpdesk',
  title: 'Helpdesk',
  type: 'group',
  children: [
    {
      id: 'back-to-core-helpdesk',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    // Operação é o primeiro destino depois da volta: é a tela que o líder de turno deixa aberta
    // o dia inteiro, e quem abre o Helpdesk de manhã quer a fila ao vivo antes do histórico.
    {
      id: 'helpdesk-operacao',
      title: 'Operação',
      type: 'item',
      url: '/helpdesk/operacao',
      icon: RadarChartOutlined,
      permissions: ['helpdesk.ticket.view'],
      breadcrumbs: false
    },
    // Conversas de WhatsApp: a fila de atendimento em tempo real (o chamado nasce da conversa).
    {
      id: 'helpdesk-conversas',
      title: 'Conversas',
      type: 'item',
      url: '/helpdesk/conversas',
      icon: MessageOutlined,
      permissions: ['helpdesk.whatsapp.atender'],
      breadcrumbs: false
    },
    {
      id: 'helpdesk-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/helpdesk/dashboard',
      icon: DashboardOutlined,
      permissions: ['helpdesk.dashboard.view'],
      breadcrumbs: false
    },
    // O trio do ITIL lado a lado: incidente, problema, mudança. "Problemas (ITIL)" e "Mudanças (RFC)"
    // perderam os parênteses — o contexto já diz o que são.
    {
      id: 'helpdesk-tickets',
      title: 'Tickets',
      type: 'item',
      url: '/helpdesk/tickets',
      icon: CustomerServiceOutlined,
      permissions: ['helpdesk.ticket.view'],
      breadcrumbs: false
    },
    // Fora de Relatórios de propósito: lá a permissão é helpdesk.relatorios.view, que o Cliente
    // Técnico não tem, e este relatório (o da reunião semanal com o cliente) ele precisa ver.
    {
      id: 'helpdesk-atividades',
      title: 'Atividades do período',
      type: 'item',
      url: '/helpdesk/atividades',
      icon: ScheduleOutlined,
      permissions: ['helpdesk.ticket.view'],
      breadcrumbs: false
    },
    {
      id: 'helpdesk-problemas',
      title: 'Problemas',
      type: 'item',
      url: '/helpdesk/itil/problemas',
      icon: BugOutlined,
      permissions: ['helpdesk.itil.problema.view'],
      breadcrumbs: false
    },
    {
      id: 'helpdesk-rfcs',
      title: 'Mudanças',
      type: 'item',
      url: '/helpdesk/itil/rfcs',
      icon: RetweetOutlined,
      permissions: ['helpdesk.itil.rfc.view'],
      breadcrumbs: false
    },
    {
      id: 'helpdesk-kb',
      title: 'Base de conhecimento',
      type: 'item',
      url: '/helpdesk/kb',
      icon: BookOutlined,
      permissions: ['helpdesk.kb.view'],
      breadcrumbs: false
    },
    {
      id: 'helpdesk-relatorios',
      title: 'Relatórios',
      type: 'item',
      url: '/helpdesk/relatorios',
      icon: FileTextOutlined,
      permissions: ['helpdesk.relatorios.view'],
      breadcrumbs: false
    },

    // Ativos: a operação sobre o parque. "Ativos", e não "Inventário", porque quem entra aqui para um
    // desligamento (RH) ou um empréstimo não pensa em inventário — pensa no equipamento.
    {
      id: 'helpdesk-ativos',
      title: 'Ativos',
      type: 'collapse',
      icon: AppstoreOutlined,
      children: [
        {
          // Primeiro filho: é a visão que diz o que decidir hoje; o inventário é onde se confere.
          id: 'helpdesk-cmdb-painel',
          title: 'Painel',
          type: 'item',
          url: '/helpdesk/cmdb/painel',
          icon: DashboardOutlined,
          permissions: ['helpdesk.cmdb.view'],
          breadcrumbs: false
        },
        {
          id: 'helpdesk-cmdb',
          title: 'Inventário',
          type: 'item',
          url: '/helpdesk/cmdb',
          icon: DatabaseOutlined,
          permissions: ['helpdesk.cmdb.view'],
          breadcrumbs: false
        },
        {
          id: 'helpdesk-emprestimos',
          title: 'Empréstimos',
          type: 'item',
          url: '/helpdesk/emprestimos',
          icon: UserSwitchOutlined,
          permissions: ['helpdesk.cmdb.view'],
          breadcrumbs: false
        },
        {
          id: 'helpdesk-consumiveis',
          title: 'Suprimentos',
          type: 'item',
          url: '/helpdesk/consumiveis',
          icon: InboxOutlined,
          permissions: ['helpdesk.cmdb.view'],
          breadcrumbs: false
        },
        {
          // "Contratos de fornecedores", porque "Contratos" sozinho colide com Comercial › Contratos,
          // que é outra coisa. Aqui são locação, garantia, link e licença de ativos.
          id: 'helpdesk-contratos',
          title: 'Contratos de fornecedores',
          type: 'item',
          url: '/helpdesk/contratos',
          icon: ProfileOutlined,
          permissions: ['helpdesk.cmdb.view'],
          breadcrumbs: false
        },
        {
          id: 'helpdesk-termos',
          title: 'Termos de responsabilidade',
          type: 'item',
          url: '/helpdesk/cmdb/conformidade',
          icon: FileProtectOutlined,
          permissions: ['helpdesk.cmdb.view'],
          breadcrumbs: false
        },
        {
          id: 'helpdesk-desligamento',
          title: 'Desligamento',
          type: 'item',
          url: '/helpdesk/cmdb/desligamento',
          icon: LogoutOutlined,
          permissions: ['helpdesk.cmdb.view'],
          breadcrumbs: false
        }
      ]
    },

    // Configurações em blocos por assunto. Eram 11 itens de quatro assuntos embaralhados; Automações
    // e Templates desceram para cá porque são configuração, não trabalho diário.
    {
      id: 'helpdesk-configuracoes',
      title: 'Configurações',
      type: 'collapse',
      icon: SettingOutlined,
      children: [
        {
          id: 'helpdesk-config-atendimento',
          title: 'Atendimento',
          type: 'collapse',
          icon: CustomerServiceOutlined,
          children: [
            {
              id: 'helpdesk-categorias',
              title: 'Categorias',
              type: 'item',
              url: '/helpdesk/configuracoes/categorias',
              icon: FolderOutlined,
              permissions: ['helpdesk.categoria.manage']
            },
            {
              id: 'helpdesk-grupos',
              title: 'Grupos',
              type: 'item',
              url: '/helpdesk/configuracoes/grupos',
              icon: TeamOutlined,
              permissions: ['helpdesk.grupo.manage']
            },
            {
              id: 'helpdesk-sla',
              title: 'SLA',
              type: 'item',
              url: '/helpdesk/configuracoes/sla',
              icon: ClockCircleOutlined,
              permissions: ['helpdesk.sla.manage']
            },
            {
              id: 'helpdesk-calendarios',
              title: 'Calendários de SLA',
              type: 'item',
              url: '/helpdesk/configuracoes/calendarios',
              icon: CalendarOutlined,
              permissions: ['helpdesk.sla.manage']
            },
            {
              id: 'helpdesk-tags',
              title: 'Tags',
              type: 'item',
              url: '/helpdesk/configuracoes/tags',
              icon: TagsOutlined,
              permissions: ['helpdesk.tag.manage']
            },
            {
              id: 'helpdesk-templates',
              title: 'Templates de ticket',
              type: 'item',
              url: '/helpdesk/templates',
              icon: FormOutlined,
              permissions: ['helpdesk.templates.manage']
            },
            {
              id: 'helpdesk-regras-chamado',
              title: 'Regras de entrada',
              type: 'item',
              url: '/helpdesk/regras-chamado',
              icon: FilterOutlined,
              permissions: ['helpdesk.automacoes.view']
            },
            {
              id: 'helpdesk-automacoes',
              title: 'Automações',
              type: 'item',
              url: '/helpdesk/automacoes',
              icon: ThunderboltOutlined,
              permissions: ['helpdesk.automacoes.view']
            }
          ]
        },
        {
          // A configuração do inventário vive aqui, e não dentro de "Ativos", para operação e
          // configuração não se misturarem no mesmo grupo — era exatamente o que confundia
          // "Termos de responsabilidade" com "Modelos de termo" quando os dois estavam soltos.
          id: 'helpdesk-config-inventario',
          title: 'Inventário',
          type: 'collapse',
          icon: DatabaseOutlined,
          children: [
            {
              id: 'helpdesk-catalogo-inventario',
              title: 'Catálogo',
              type: 'item',
              url: '/helpdesk/configuracoes/catalogo-inventario',
              icon: UnorderedListOutlined,
              permissions: ['helpdesk.cmdb.catalogos.manage']
            },
            {
              id: 'helpdesk-cmdb-campos',
              title: 'Campos',
              type: 'item',
              url: '/helpdesk/configuracoes/cmdb-campos',
              icon: FormOutlined,
              permissions: ['helpdesk.cmdb.catalogos.manage']
            },
            {
              id: 'helpdesk-inventario-tokens',
              title: 'Tokens de inventário',
              type: 'item',
              url: '/helpdesk/configuracoes/inventario-tokens',
              icon: KeyOutlined,
              permissions: ['helpdesk.cmdb.manage']
            },
            {
              id: 'helpdesk-termo-modelos',
              title: 'Modelos de termo',
              type: 'item',
              url: '/helpdesk/cmdb/termo-modelos',
              icon: FileProtectOutlined,
              permissions: ['helpdesk.cmdb.view']
            },
            {
              id: 'helpdesk-cmdb-importacao',
              title: 'Importar ativos',
              type: 'item',
              url: '/helpdesk/cmdb/importacao',
              icon: UploadOutlined,
              permissions: ['helpdesk.cmdb.import']
            }
          ]
        },
        {
          id: 'helpdesk-config-canais',
          title: 'Canais',
          type: 'collapse',
          icon: MailOutlined,
          children: [
            {
              id: 'helpdesk-mailboxes',
              title: 'Caixas de e-mail',
              type: 'item',
              url: '/helpdesk/configuracoes/mailboxes',
              icon: MailOutlined,
              permissions: ['helpdesk.mailbox.manage']
            },
            {
              id: 'helpdesk-dominios-cliente',
              title: 'Domínios de cliente',
              type: 'item',
              url: '/helpdesk/configuracoes/dominios-cliente',
              icon: GlobalOutlined,
              permissions: ['helpdesk.mailbox.manage']
            }
          ]
        },
        {
          id: 'helpdesk-usuarios-clientes',
          title: 'Usuários de clientes',
          type: 'item',
          url: '/helpdesk/configuracoes/usuarios-clientes',
          icon: UsergroupAddOutlined,
          permissions: ['auth.users.provisionar_cliente']
        }
      ]
    }
  ]
};

export default helpdesk;
